var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttentionSmallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 2.07692C7.19121 2.07692 2.07692 7.19121 2.07692 13.5C2.07692 19.8088 7.19121 24.923 13.5 24.923C19.8088 24.923 24.923 19.8088 24.923 13.5C24.923 7.19121 19.8088 2.07692 13.5 2.07692ZM0 13.5C0 6.04415 6.04415 0 13.5 0C20.9558 0 27 6.04415 27 13.5C27 20.9558 20.9558 27 13.5 27C6.04415 27 0 20.9558 0 13.5Z",
    fill: "#C03658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4994 7.61548C14.0728 7.61548 14.5378 8.08041 14.5378 8.65394V14.1924C14.5378 14.766 14.0728 15.2309 13.4994 15.2309C12.9259 15.2309 12.4609 14.766 12.4609 14.1924V8.65394C12.4609 8.08041 12.9259 7.61548 13.4994 7.61548Z",
    fill: "#C03658"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8824 18.346C14.8824 19.1108 14.2625 19.7307 13.4978 19.7307C12.7332 19.7307 12.1133 19.1108 12.1133 18.346C12.1133 17.5813 12.7332 16.9614 13.4978 16.9614C14.2625 16.9614 14.8824 17.5813 14.8824 18.346Z",
    fill: "#C03658"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionSmallIcon);
export default __webpack_public_path__ + "static/media/attention-small-icon.31e04baa3501fe7db4aa0903ee830153.svg";
export { ForwardRef as ReactComponent };